const CommercialBankingReport = () =>
  import(
    /* webpackChunkName: "financial-commercial-banking" */ '@/pages/financial/commercial-banking/commercial-banking/index.vue'
  )

const CreateCommercialBanking = () =>
  import(
    /* webpackChunkName: "financial-commercial-banking" */ '@/pages/financial/commercial-banking/commercial-banking/create.vue'
  )

export default {
  path: 'commercial-banking',
  meta: {
    label: 'commercialBanking',
    auth: true
  },
  component: {
    name: 'CommercialBanking',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CreateCommercialBanking',
      path: 'create',
      meta: {
        label: 'report'
      },
      component: CreateCommercialBanking
    },
    {
      name: 'CommercialBankingReport',
      path: '',
      meta: {
        label: 'report'
      },
      component: CommercialBankingReport
    }
  ]
}
